export default __webpack_public_path__ + "static/media/Plus.8a96885d.png";